import VisitorAgreementStep from './VisitorAgreementStep';

export default VisitorAgreementStep;
